var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.successTransfer)?_c('div',[_c('div',{staticClass:"swap-modal-align-center"},[_c('span',{staticClass:"sg-vrm-icon_146_restart_32px vrm-modal__title-icon"}),_c('div',{staticClass:"vrm-modal__title",domProps:{"innerHTML":_vm._s(
                _vm.$t(`general.confirm_replace_modal.last_step.almost`, {
                    i18nFallback: 'Almost done! Please restart your replacement GX device',
                })
            )}})]),_c('div',{staticClass:"vrm-modal__content swap-modal-align-center"},[_c('div',{staticClass:"vrm-modal__text",domProps:{"innerHTML":_vm._s(
                _vm.$t(`general.confirm_replace_modal.last_step.final_step`, {
                    i18nFallback:
                        'As a final step you need to <b>manually restart</b> your replacement GX device.<br/>How to do this can be found in the manual of the device.',
                })
            )}}),_c('br'),_c('button',{staticClass:"sg-btn sg-blue",on:{"click":function($event){return _vm.confirmClose()}}},[_vm._v("\n            "+_vm._s(_vm.$t(`general.confirm_replace_modal.last_step.got_it`, {
                    i18nFallback: 'Got it, close this window',
                }))+"\n        ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }